import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ListMusic, Play, Clock, Music } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PlaylistsPage() {
  const [playlists, setPlaylists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlaylists = async () => {
      try {
        const response = await axios.get(`${API}/playlists`);
        setPlaylists(response.data);
      } catch (error) {
        console.error("Error fetching playlists:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPlaylists();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-[#FF007F] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505]">
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 pb-16">
        {/* Header */}
        <div className="mb-12">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#00E5FF] to-[#FF007F] flex items-center justify-center">
              <ListMusic className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-white" data-testid="playlists-title">
                Playlists
              </h1>
              <p className="text-zinc-500">As melhores seleções do Arrocha</p>
            </div>
          </div>
        </div>

        {/* Playlists Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {playlists.map((playlist, index) => (
            <Link
              key={playlist.id}
              to={`/playlist/${playlist.id}`}
              className="group bg-[#121212] rounded-2xl border border-white/10 overflow-hidden hover:border-[#FF007F]/50 transition-all hover:shadow-xl hover:shadow-[#FF007F]/10 animate-fade-in-up opacity-0"
              style={{ animationDelay: `${index * 0.1}s` }}
              data-testid={`playlist-card-${index}`}
            >
              {/* Cover */}
              <div className="relative aspect-square overflow-hidden">
                {playlist.cover_image ? (
                  <img
                    src={playlist.cover_image}
                    alt={playlist.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                ) : (
                  <div className="w-full h-full bg-gradient-to-br from-[#FF007F]/30 to-[#00E5FF]/30 flex items-center justify-center">
                    <Music className="w-20 h-20 text-white/30" />
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                
                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <button className="w-16 h-16 rounded-full bg-[#FF007F] flex items-center justify-center shadow-lg shadow-[#FF007F]/30 transform scale-90 group-hover:scale-100 transition-transform">
                    <Play size={28} fill="white" className="text-white ml-1" />
                  </button>
                </div>
                
                {/* Music Count */}
                <div className="absolute bottom-4 left-4">
                  <span className="px-3 py-1 bg-black/60 backdrop-blur-sm rounded-full text-white text-sm flex items-center gap-1">
                    <Music size={14} />
                    {playlist.music_count} músicas
                  </span>
                </div>
              </div>
              
              {/* Info */}
              <div className="p-5">
                <h3 className="font-heading text-xl font-bold text-white mb-1 group-hover:text-[#FF007F] transition-colors">
                  {playlist.name}
                </h3>
                {playlist.description && (
                  <p className="text-zinc-500 text-sm line-clamp-2">
                    {playlist.description}
                  </p>
                )}
              </div>
            </Link>
          ))}
        </div>

        {/* Empty State */}
        {playlists.length === 0 && (
          <div className="text-center py-20">
            <ListMusic className="w-16 h-16 text-zinc-700 mx-auto mb-4" />
            <h3 className="font-heading text-2xl font-bold text-white mb-2">
              Nenhuma playlist ainda
            </h3>
            <p className="text-zinc-500">
              Em breve teremos playlists incríveis para você!
            </p>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}
